var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 4.2333332 4.2333335",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#CFCFCF",
      strokeWidth: 1.32292,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke",
      stopColor: "#000000"
    },
    id: "rect848",
    width: 1.0583334,
    height: 4.2333336,
    x: 1.5875,
    y: 7.9430036e-9,
    rx: 0.26458335,
    ry: 0.26458335
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#CFCFCF",
      strokeWidth: 1.32292,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke",
      stopColor: "#000000"
    },
    id: "rect1040",
    width: 1.0583334,
    height: 4.2333336,
    x: 1.5875,
    y: -4.2333336,
    transform: "rotate(90)",
    rx: 0.26458335,
    ry: 0.26458335
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.a9ec179179da54871527a3ff185cdead.svg";
export { ForwardRef as ReactComponent };